<template>
	<point-of-sale-overview />
</template>

<script>

export default {
	name: 'PointOfSales',
};
</script>
